import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { phoneNumberQueryKey } from './usePhoneNumber'
import { phoneNumbersQueryKey } from './usePhoneNumbers'

import type { PhoneNumber, PhoneNumberUpdate } from 'honeygrid-types'

interface UpdatePhoneNumberParams {
	workspaceId: string
	phoneNumberId: string
	updates: PhoneNumberUpdate
}

/**
 * Hook to update an existing phone number's configuration
 */
export const useUpdatePhoneNumber = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: async ({ workspaceId, phoneNumberId, updates }: UpdatePhoneNumberParams) => {
			return authFetch(`workspaces/${workspaceId}/phone-numbers/${phoneNumberId}`, {
				method: 'PATCH',
				body: updates,
			}) as Promise<PhoneNumber>
		},
		onSuccess: (_, { workspaceId, phoneNumberId }) => {
			// Invalidate both the list and the individual phone number queries
			queryClient.invalidateQueries({
				queryKey: phoneNumbersQueryKey(workspaceId),
			})
			queryClient.invalidateQueries({
				queryKey: phoneNumberQueryKey(workspaceId, phoneNumberId),
			})
			toast.success('Phone number updated successfully')
		},
		onError: (error: Error) => {
			toast.error(`Failed to update phone number: ${error.message}`)
		},
	})
}
